import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Box } from '@mui/system'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import { Autocomplete, Button, Grid, TextField } from '@mui/material'
import { styled } from '@mui/material/styles'
import { fetchData } from '../../Api/useFetch'
import TableCell, { tableCellClasses } from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import { showTimeInAgoFormat } from '../../Utils/Time'
import Backdrop from '@mui/material/Backdrop'
import Modal from '@mui/material/Modal'
import Fade from '@mui/material/Fade'
import { defaultModalStyle } from '../../Styles/Modal'
import { BASE_URL } from '../../Api/constants'
import DrawerNav from '../Navigation/DrawerNav'

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.primary.dark,
        color: theme.palette.common.white,
        fontSize: 20
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 16
    }
}))

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0
    }
}))

function ReportedQuestions() {
    const location = useLocation()
    const navigate = useNavigate()
    const [apiCalled, setApiCalled] = useState(false)
    const [submissionsList, setSubmissionsList] = useState([])

    // MODAL
    const [open, setOpen] = React.useState(false)
    //EditModal
    const handleOpen = (reward) => {
        setQuestionData(reward)
        console.log('New data : ', reward)
        setOpen(true)
    }
    const handleClose = () => setOpen(false)

    const handleEditQuestion = (id) => {
        navigate('/edit-question?id=' + id)
    }

    const [questionData, setQuestionData] = useState({
        email: '',
        subject: '',
        body: '',
        response: '',
        submittedAt: 0,
        status: 'pending'
    })

    const updateQuestionData = (property, value, index = null) => {
        setQuestionData((prevData) => {
            return {
                ...prevData,
                [property]: value
            }
        })
    }

    const getSubmissionsList = async (contestId) => {
        const data = await fetchData(`api/user/quiz/report`)
        console.log('Data : ', data)
        if (data) {
            setApiCalled(true)
            setSubmissionsList(data.reportedList)
        }
    }

    const saveRewardState = () => {
        const requestOptions = {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' }
        }

        console.log('ID : ', questionData._id)

        fetch(`${BASE_URL}/api/user/quiz/question/report/${questionData._id}`, requestOptions)
            .then((response) => response.json())
            .then((data) => {
                console.log('Data: ', data)
                if (data.status === 200) {
                    handleClose()
                    getSubmissionsList()
                } else {
                }
            })
    }

    useEffect(() => {
        const path = location.pathname
        if (!apiCalled) {
            getSubmissionsList()
        }
    }, [apiCalled, location.pathname])

    return (
        <>
            <Box sx={{ display: 'flex' }}>
                <DrawerNav />
                <Box component='main' sx={{ flexGrow: 1, p: 3 }}>
                    <div className='pb-96'>
                        <Box sx={{ flexGrow: 2 }}>
                            <h1 className='my-5 text-2xl font-bold text-center text-gray-500'>Reported Questions</h1>
                            <Grid align='center' justify='center' sx={{ margin: 1 }}>
                                <>
                                    <Table sx={{ width: '90%', marginTop: 4, marginBottom: 30 }} aria-label='customized table'>
                                        <TableHead>
                                            <TableRow>
                                                <StyledTableCell align='left'>Question</StyledTableCell>
                                                <StyledTableCell align='left'>UID</StyledTableCell>
                                                <StyledTableCell align='left'>Username</StyledTableCell>
                                                <StyledTableCell align='left'>Remark</StyledTableCell>
                                                <StyledTableCell align='left'>Time</StyledTableCell>
                                                <StyledTableCell align='left'>Edit</StyledTableCell>
                                                <StyledTableCell align='left'>Resolve</StyledTableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {submissionsList.length > 0 &&
                                                submissionsList.map((data, index) => {
                                                    return (
                                                        <StyledTableRow key={data._id} sx={{ border: '1px solid gray' }}>
                                                            <StyledTableCell align='left'>{data.Question && data.Question.question}</StyledTableCell>
                                                            <StyledTableCell align='left'>{data.uid}</StyledTableCell>
                                                            <StyledTableCell align='left'>{data.User && data.User.username}</StyledTableCell>
                                                            <StyledTableCell align='left'>{data.remark}</StyledTableCell>
                                                            <StyledTableCell align='left'>{showTimeInAgoFormat(data.reportedAt)}</StyledTableCell>
                                                            <StyledTableCell align='left' onClick={() => handleEditQuestion(data.questionId)}>
                                                                <span className='text-blue-500 underline cursor-pointer'>Edit</span>
                                                            </StyledTableCell>
                                                            <StyledTableCell align='left' onClick={() => handleOpen(data)}>
                                                                <span className='text-blue-500 underline cursor-pointer'>Resolve</span>
                                                            </StyledTableCell>
                                                        </StyledTableRow>
                                                    )
                                                })}
                                        </TableBody>
                                    </Table>
                                </>
                            </Grid>
                        </Box>
                        <Modal
                            aria-labelledby='transition-modal-title'
                            aria-describedby='transition-modal-description'
                            open={open}
                            onClose={handleClose}
                            closeAfterTransition
                            slots={{ backdrop: Backdrop }}
                            slotProps={{
                                backdrop: {
                                    timeout: 500
                                }
                            }}>
                            <Fade in={open}>
                                <Box sx={defaultModalStyle}>
                                    <div className='flex flex-col gap-6 justify-center'>
                                        <h1 className='text-center text-2xl font-bold text-gray-700'>Has the question been resolved?</h1>
                                        {/* <TextField
                                    id='outlined-controlled'
                                    disabled={true}
                                    label='Email'
                                    sx={{ width: '100%' }}
                                    value={questionData.email}
                                    onChange={(event) => {
                                        updateQuestionData('email', event.target.value)
                                    }}
                                />
                                <TextField
                                    id='outlined-controlled'
                                    disabled={true}
                                    label='Subject'
                                    sx={{ width: '100%' }}
                                    value={questionData.subject}
                                    onChange={(event) => {
                                        updateQuestionData('subject', event.target.value)
                                    }}
                                />
                                <TextField
                                    id='outlined-controlled'
                                    disabled={true}
                                    label='Body'
                                    sx={{ width: '100%' }}
                                    value={questionData.body}
                                    onChange={(event) => {
                                        updateQuestionData('body', event.target.value)
                                    }}
                                />
                                <TextField
                                    id='outlined-controlled'
                                    disabled={true}
                                    label='Created At'
                                    sx={{ width: '100%' }}
                                    value={showTimeInAgoFormat(questionData.submittedAt)}
                                    onChange={(event) => {
                                        updateQuestionData('submittedAt', event.target.value)
                                    }}
                                />
                                <TextField
                                    id='outlined-controlled'
                                    label='Response'
                                    sx={{ width: '100%' }}
                                    value={questionData.response}
                                    onChange={(event) => {
                                        updateQuestionData('response', event.target.value)
                                    }}
                                />
                                <Autocomplete
                                    disablePortal
                                    id='combo-box-demo'
                                    value={questionData.status}
                                    options={['Pending', 'Resolved']}
                                    sx={{ width: '100%' }}
                                    onChange={(event, item) => {
                                        console.log('Event : ', event)
                                        updateQuestionData('status', item)
                                    }}
                                    renderInput={(params) => <TextField {...params} label='Reward Status' />}
                                /> */}
                                        <Button variant='contained' color='success' sx={{ width: '100%', cursor: 'pointer' }} onClick={saveRewardState}>
                                            Resolve
                                        </Button>
                                    </div>
                                </Box>
                            </Fade>
                        </Modal>
                    </div>
                </Box>
            </Box>
        </>
    )
}

export default ReportedQuestions
